/*
Purpose: Generic confirmation dialog for the destructive Calendar (v2) actions.
Project: TCMS
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from '@mui/material/Button';

export default function ConfirmDialog({
  show,
  title,
  message,
  confirmLabel,
  isSubmitting,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title as="h5">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{message}</Modal.Body>

      <Modal.Footer className="pt-0">
        <div className="mx-auto d-flex gap-2">
          <Button variant="contained" className="primary-gray" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className="primary-filled"
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {confirmLabel}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

ConfirmDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
  confirmLabel: 'Confirm',
  isSubmitting: false,
};
